import { InjectionToken, Injectable, ɵɵdefineInjectable, ɵɵinject, Inject, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpErrorResponse, HttpClient } from '@angular/common/http';
import { throwError, of } from 'rxjs';
import { map, catchError, retryWhen, concatMap, take, delay, mergeMap, tap } from 'rxjs/operators';
import { createAction, createSelector, createReducer, on, select, Store, StoreModule } from '@ngrx/store';
import Debug from 'debug';
import jwt_decode from 'jwt-decode';
import { CookieService } from 'ngx-cookie-service';
import { Router, RouterModule } from '@angular/router';
import { createEffect, ofType, Actions, EffectsModule } from '@ngrx/effects';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/Auth.config.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function ModesoAuthConfig() { }
if (false) {
    /** @type {?} */
    ModesoAuthConfig.prototype.serviceId;
    /** @type {?} */
    ModesoAuthConfig.prototype.apiGateway;
}
/** @type {?} */
const ModesoAuthConfigService = new InjectionToken('Config');

/**
 * @fileoverview added by tsickle
 * Generated from: lib/actions/auth.actions.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const onGetNewAccesToken = createAction('[modeso auth] get new access token');
/** @type {?} */
const onGetNewSession = createAction('[modeso auth] get new session');
/** @type {?} */
const onGetNewAccesTokenFailed = createAction('[modeso auth] get new Acces token Failed');
/** @type {?} */
const onGetNewSessionFailed = createAction('[modeso auth] get new session failed');
/** @type {?} */
const onGetNewSessionSuccess = createAction('[modeso auth] get new session success');
/** @type {?} */
const onGetNewAccesTokenSuccess = createAction('[modeso auth] get new Acces token success');
/**
 * @record
 * @template T
 */
function IActionWithPayload() { }
if (false) {
    /** @type {?} */
    IActionWithPayload.prototype.payload;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/reducers/auth.reducer.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const featureKey = 'modesoAuthMicroservice';
/**
 * @record
 */
function FeatureState() { }
if (false) {
    /** @type {?} */
    FeatureState.prototype.chekInDate;
}
/**
 * @record
 */
function AppState() { }
if (false) {
    /** @type {?} */
    AppState.prototype.modesoAuthMicroservice;
}
/** @type {?} */
const selectFeature = (/**
 * @param {?} state
 * @return {?}
 */
(state) => state.modesoAuthMicroservice);
const ɵ0 = /**
 * @param {?} state
 * @return {?}
 */
(state) => state;
/** @type {?} */
const selectFeatureSession = createSelector(selectFeature, (ɵ0));
const ɵ1 = /**
 * @param {?} state
 * @return {?}
 */
(state) => state.chekInDate;
/** @type {?} */
const selectCheckInate = createSelector(selectFeature, (ɵ1));
/** @type {?} */
const initialState = {
    chekInDate: null,
};
const ɵ2 = /**
 * @param {?} state
 * @return {?}
 */
(state) => {
    return Object.assign({}, state);
}, ɵ3 = /**
 * @param {?} state
 * @return {?}
 */
(state) => {
    return Object.assign({}, state);
}, ɵ4 = /**
 * @param {?} state
 * @return {?}
 */
(state) => {
    return Object.assign({}, state);
}, ɵ5 = /**
 * @param {?} state
 * @return {?}
 */
(state) => {
    return Object.assign({}, state);
}, ɵ6 = /**
 * @param {?} state
 * @return {?}
 */
(state) => {
    return Object.assign({}, state);
}, ɵ7 = /**
 * @param {?} state
 * @return {?}
 */
(state) => {
    return Object.assign({}, state);
};
/** @type {?} */
const authReducer = createReducer(initialState, on(onGetNewAccesToken, (ɵ2)), on(onGetNewSession, (ɵ3)), on(onGetNewAccesTokenFailed, (ɵ4)), on(onGetNewSessionFailed, (ɵ5)), on(onGetNewSessionSuccess, (ɵ6)), on(onGetNewAccesTokenSuccess, (ɵ7)));
/**
 * @param {?} state
 * @param {?} action
 * @return {?}
 */
function reducer(state, action) {
    return authReducer(state, action);
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/shared/services/jwt.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class JWTService {
    /**
     * @param {?} jwtToken
     * @return {?}
     */
    decodeJwt(jwtToken) {
        return jwt_decode(jwtToken);
    }
    /**
     * @param {?} jwtToken
     * @return {?}
     */
    getCheckInDateFromJWT(jwtToken) {
        /** @type {?} */
        const decodedToken = (/** @type {?} */ (this.decodeJwt(jwtToken)));
        return decodedToken.checkInDate;
    }
}
JWTService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root',
            },] }
];
/** @nocollapse */ JWTService.ngInjectableDef = ɵɵdefineInjectable({ factory: function JWTService_Factory() { return new JWTService(); }, token: JWTService, providedIn: "root" });

/**
 * @fileoverview added by tsickle
 * Generated from: lib/provider/auth.provider.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const debug = Debug('auth:AuthProvider');
class AuthProvider {
    /**
     * @param {?} store
     * @param {?} cookieService
     * @param {?} jwtService
     */
    constructor(store, cookieService, jwtService) {
        this.store = store;
        this.cookieService = cookieService;
        this.jwtService = jwtService;
    }
    /**
     * @return {?}
     */
    getNewAccsessToken() {
        this.store.dispatch(onGetNewAccesToken());
    }
    /**
     * @return {?}
     */
    getNewSession() {
        this.store.dispatch(onGetNewSession());
    }
    /**
     * @return {?}
     */
    isAllowedToCheckout$() {
        return this.store.pipe(select(selectCheckInate), map((/**
         * @param {?} checkInDate
         * @return {?}
         */
        (checkInDate) => {
            /** @type {?} */
            const savedCheckinDate = localStorage.getItem('checkInDate');
            // if store is empty load checkin date from local storage
            checkInDate = checkInDate ? checkInDate : (savedCheckinDate ?
                new Date(savedCheckinDate) : null);
            if (checkInDate === null || checkInDate === undefined) {
                return false;
            }
            /** @type {?} */
            const offset15min = 15 * 60 * 1000;
            try {
                if (new Date(checkInDate).getTime() + offset15min >
                    new Date().getTime()) {
                    return true;
                }
                else {
                    return false;
                }
            }
            catch (error) {
                debug(error);
                return false;
            }
        })));
    }
}
AuthProvider.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root',
            },] }
];
/** @nocollapse */
AuthProvider.ctorParameters = () => [
    { type: Store },
    { type: CookieService },
    { type: JWTService }
];
/** @nocollapse */ AuthProvider.ngInjectableDef = ɵɵdefineInjectable({ factory: function AuthProvider_Factory() { return new AuthProvider(ɵɵinject(Store), ɵɵinject(CookieService), ɵɵinject(JWTService)); }, token: AuthProvider, providedIn: "root" });
if (false) {
    /** @type {?} */
    AuthProvider.prototype.store;
    /**
     * @type {?}
     * @private
     */
    AuthProvider.prototype.cookieService;
    /**
     * @type {?}
     * @private
     */
    AuthProvider.prototype.jwtService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/shared/services/redirection.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class RedirectionHandler {
    /**
     * @param {?} router
     */
    constructor(router) {
        this.router = router;
    }
    /**
     * @return {?}
     */
    redirectUser() {
        this.router.navigateByUrl(`/${localStorage.getItem('currentLanguage')}`);
    }
}
RedirectionHandler.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root',
            },] }
];
/** @nocollapse */
RedirectionHandler.ctorParameters = () => [
    { type: Router }
];
/** @nocollapse */ RedirectionHandler.ngInjectableDef = ɵɵdefineInjectable({ factory: function RedirectionHandler_Factory() { return new RedirectionHandler(ɵɵinject(Router)); }, token: RedirectionHandler, providedIn: "root" });
if (false) {
    /**
     * @type {?}
     * @private
     */
    RedirectionHandler.prototype.router;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/shared/interceptors/authentication.interceptor.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class AuthHandlerInterceptor {
    /**
     * @param {?} redirectionHandler
     * @param {?} authProvider
     */
    constructor(redirectionHandler, authProvider) {
        this.redirectionHandler = redirectionHandler;
        this.authProvider = authProvider;
    }
    /**
     * @param {?} req
     * @param {?} next
     * @return {?}
     */
    intercept(req, next) {
        /** @type {?} */
        const modifiedRequest = req.clone({
            withCredentials: true,
        });
        return next.handle(modifiedRequest).pipe(catchError((/**
         * @param {?} err
         * @return {?}
         */
        (err) => {
            if (err instanceof HttpErrorResponse) {
                if (err.status === 440) { // Session Invalid
                    this.authProvider.getNewSession();
                    this.redirectionHandler.redirectUser();
                }
            }
            return throwError(err);
        })), retryWhen((/**
         * @param {?} errors
         * @return {?}
         */
        (errors) => {
            return errors.pipe(concatMap((/**
             * @param {?} error
             * @return {?}
             */
            (error) => {
                if (error.status === 401) {
                    this.authProvider.getNewAccsessToken();
                    return of(error.status);
                }
                return throwError(error);
            })), take(2), delay(1000));
        })));
    }
}
AuthHandlerInterceptor.decorators = [
    { type: Injectable }
];
/** @nocollapse */
AuthHandlerInterceptor.ctorParameters = () => [
    { type: RedirectionHandler },
    { type: AuthProvider }
];
if (false) {
    /**
     * @type {?}
     * @private
     */
    AuthHandlerInterceptor.prototype.redirectionHandler;
    /**
     * @type {?}
     * @private
     */
    AuthHandlerInterceptor.prototype.authProvider;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/authentication.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class AuthenticationService {
    /**
     * @param {?} http
     * @param {?} config
     */
    constructor(http, config) {
        this.http = http;
        this.config = config;
        this.server = '';
        this.microserviceName = 'auth';
        this.server = config.apiGateway || 'http://localhost:3100/api';
    }
    /**
     * @return {?}
     */
    getNewSessionToken() {
        /** @type {?} */
        const url = `${this.server}${this.microserviceName}/initializeAanonymousUserSession`;
        return this.http.post(url, null);
    }
    /**
     * @return {?}
     */
    getNewAccessToken() {
        /** @type {?} */
        const url = `${this.server}${this.microserviceName}/refreshAanonymousUserToken`;
        return this.http.post(url, null);
    }
}
AuthenticationService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root',
            },] }
];
/** @nocollapse */
AuthenticationService.ctorParameters = () => [
    { type: HttpClient },
    { type: undefined, decorators: [{ type: Inject, args: [ModesoAuthConfigService,] }] }
];
/** @nocollapse */ AuthenticationService.ngInjectableDef = ɵɵdefineInjectable({ factory: function AuthenticationService_Factory() { return new AuthenticationService(ɵɵinject(HttpClient), ɵɵinject(ModesoAuthConfigService)); }, token: AuthenticationService, providedIn: "root" });
if (false) {
    /**
     * @type {?}
     * @private
     */
    AuthenticationService.prototype.server;
    /**
     * @type {?}
     * @private
     */
    AuthenticationService.prototype.microserviceName;
    /**
     * @type {?}
     * @private
     */
    AuthenticationService.prototype.http;
    /**
     * @type {?}
     * @private
     */
    AuthenticationService.prototype.config;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/effects/auth.effect.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class AuthEffects {
    /**
     * @param {?} actions$
     * @param {?} service
     * @param {?} cookieService
     * @param {?} jwtService
     */
    constructor(actions$, service, cookieService, jwtService) {
        this.actions$ = actions$;
        this.service = service;
        this.cookieService = cookieService;
        this.jwtService = jwtService;
        this.onGetNewAccessToken$ = createEffect((/**
         * @return {?}
         */
        () => {
            return this.actions$.pipe(ofType(onGetNewAccesToken.type), mergeMap((/**
             * @return {?}
             */
            () => {
                return this.service.getNewAccessToken().pipe(map((/**
                 * @param {?} reponse
                 * @return {?}
                 */
                (reponse) => {
                    return onGetNewAccesTokenSuccess();
                })), catchError((/**
                 * @param {?} err
                 * @return {?}
                 */
                (err) => {
                    return of(onGetNewAccesTokenFailed());
                })));
            })));
        }));
        this.onGetNewSession$ = createEffect((/**
         * @return {?}
         */
        () => {
            return this.actions$.pipe(ofType(onGetNewSession.type), mergeMap((/**
             * @return {?}
             */
            () => {
                return this.service.getNewSessionToken().pipe(map((/**
                 * @param {?} reponse
                 * @return {?}
                 */
                (reponse) => {
                    this.saveUserRole();
                    return onGetNewSessionSuccess();
                })), catchError((/**
                 * @param {?} err
                 * @return {?}
                 */
                (err) => {
                    return of(onGetNewSessionFailed());
                })));
            })));
        }));
        this.onGetNewSessionSuccess$ = createEffect((/**
         * @return {?}
         */
        () => {
            return this.actions$.pipe(ofType(onGetNewSessionSuccess.type), tap((/**
             * @return {?}
             */
            () => {
                console.log('Session succeed to be retrieved');
            })));
        }), { dispatch: false });
        this.onGetNewTokenSuccess$ = createEffect((/**
         * @return {?}
         */
        () => {
            return this.actions$.pipe(ofType(onGetNewAccesTokenSuccess.type), tap((/**
             * @return {?}
             */
            () => {
                console.log('Token succeed to be retrieved');
            })));
        }), { dispatch: false });
        this.onGetNewSessionFailed$ = createEffect((/**
         * @return {?}
         */
        () => {
            return this.actions$.pipe(ofType(onGetNewSessionFailed.type), tap((/**
             * @return {?}
             */
            () => {
                console.log('Session Failed to be retrieved');
            })));
        }), { dispatch: false });
        this.onGetNewTokenFailed$ = createEffect((/**
         * @return {?}
         */
        () => {
            return this.actions$.pipe(ofType(onGetNewAccesTokenFailed.type), tap((/**
             * @return {?}
             */
            () => {
                console.log('Token Failed to be retrieved');
            })));
        }), { dispatch: false });
    }
    /**
     * @private
     * @return {?}
     */
    saveUserRole() {
        /** @type {?} */
        const token = this.cookieService.get('token');
        /** @type {?} */
        const userRoles = (/** @type {?} */ (this.jwtService.decodeJwt(token)));
        localStorage.setItem('roles', JSON.stringify(userRoles.roles));
    }
}
AuthEffects.decorators = [
    { type: Injectable }
];
/** @nocollapse */
AuthEffects.ctorParameters = () => [
    { type: Actions },
    { type: AuthenticationService },
    { type: CookieService },
    { type: JWTService }
];
if (false) {
    /** @type {?} */
    AuthEffects.prototype.onGetNewAccessToken$;
    /** @type {?} */
    AuthEffects.prototype.onGetNewSession$;
    /** @type {?} */
    AuthEffects.prototype.onGetNewSessionSuccess$;
    /** @type {?} */
    AuthEffects.prototype.onGetNewTokenSuccess$;
    /** @type {?} */
    AuthEffects.prototype.onGetNewSessionFailed$;
    /** @type {?} */
    AuthEffects.prototype.onGetNewTokenFailed$;
    /**
     * @type {?}
     * @private
     */
    AuthEffects.prototype.actions$;
    /**
     * @type {?}
     * @private
     */
    AuthEffects.prototype.service;
    /**
     * @type {?}
     * @private
     */
    AuthEffects.prototype.cookieService;
    /**
     * @type {?}
     * @private
     */
    AuthEffects.prototype.jwtService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/Auth.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ModesoAuthModule {
    /**
     * @param {?} config
     * @return {?}
     */
    static forRoot(config) {
        return {
            ngModule: ModesoAuthModule,
            providers: [
                AuthHandlerInterceptor,
                {
                    provide: ModesoAuthConfigService,
                    useValue: config,
                },
            ],
        };
    }
}
ModesoAuthModule.decorators = [
    { type: NgModule, args: [{
                providers: [AuthHandlerInterceptor, CookieService],
                imports: [
                    CommonModule,
                    BrowserAnimationsModule,
                    RouterModule,
                    StoreModule.forFeature(featureKey, reducer),
                    EffectsModule.forFeature([AuthEffects]),
                ],
                exports: [],
            },] }
];

/**
 * @fileoverview added by tsickle
 * Generated from: public-api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: modeso-modeso-lib-auth-fe.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { AuthHandlerInterceptor, AuthProvider, AuthenticationService, ModesoAuthConfigService, ModesoAuthModule, RedirectionHandler, featureKey as ɵa, initialState as ɵc, reducer as ɵd, JWTService as ɵe, onGetNewAccesToken as ɵf, onGetNewSession as ɵg, onGetNewAccesTokenFailed as ɵh, onGetNewSessionFailed as ɵi, onGetNewSessionSuccess as ɵj, onGetNewAccesTokenSuccess as ɵk, AuthEffects as ɵl };
